import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputTextComponent } from '../../../../../../../shared/components/input-text/input-text.component';
import { TranslateSafePipe } from '../../../../../../../shared/pipes/translation.pipe';
import { InputTextInterface } from '../../../../../../../types/interfaces/input.interface';

@Component({
  selector: 'app-cron-trigger',
  imports: [
    InputTextComponent,
    TranslateSafePipe,
  ],
  templateUrl: './cron-trigger.html',
  styleUrls: [
    './cron-trigger.css',
    '../base-rule-condtion.css',
  ],
})
export class CronTrigger {
  @Input({required: true}) formGroup!: FormGroup;

  public getCronInput(): InputTextInterface {
    return {
      formGroup: this.formGroup,
      label: 'Cron',
      type: 'text',
      required: true,
      id: 'cron',
    };
  }

}
